import React, { useState, useEffect } from 'react';
import { frontendDb as db } from '../../lib/frontend-db';

const StimmArtPage = () => {
  const [stimmartText, setStimmartText] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const settings = await db.getSettings();
      if (settings) {
        setStimmartText(settings.stimmart_text || '');
      }
    } catch (error) {
      console.error('Error loading settings:', error);
      setError('Fehler beim Laden der StimmArt-Einstellungen');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError(null);

    try {
      await db.updateSettings({
        stimmart_text: stimmartText,
      });
      window.location.reload();
    } catch (error) {
      console.error('Error saving settings:', error);
      setError('Fehler beim Speichern der StimmArt-Einstellungen');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="animate-pulse">Lädt...</div>;
  }

  return (
    <div className="space-y-6">
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
          {error}
        </div>
      )}

      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-4">StimmArt</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Beschreibungstext</label>
            <textarea
              value={stimmartText}
              onChange={(e) => setStimmartText(e.target.value)}
              rows={10}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring focus:ring-green-200"
              required
            />
          </div>

          <button
            type="submit"
            disabled={saving}
            className="w-full bg-green-700 text-white py-2 px-4 rounded-md hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50"
          >
            {saving ? 'Wird gespeichert...' : 'Speichern'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default StimmArtPage;

